/* eslint-disable react/sort-comp */
/* eslint-disable react/static-property-placement */
import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';

// LIBS
import PropTypes from 'prop-types';
import * as actions from '~/store/actions';
import * as lib from '~/dependencies';
import { electron } from '~/helpers';
import { Container, TextError } from './styles';

const env = process.env.NODE_ENV;

class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      message: '',
    };
  }

  forceReload = () => {
    const { resetStates } = this.props;
    if (window.isElectron) {
      resetStates();
      // window.ipcRenderer.send('forceReload');
      electron.forceReload();
    }
  };

  componentDidCatch(err, errInfo) {
    this.setState({
      error: true,
      message: `${errInfo.componentStack.toString() + err.toString()}`,
    });
    Sentry.withScope(scope => {
      scope.setExtras(errInfo);
      Sentry.captureException(err);
    });
  }

  render() {
    const { error, message } = this.state;
    // eslint-disable-next-line
    const { children, t } = this.props;

    if (error) {
      return (
        <Container>
          <TextError fontSize={14}>
            {t('components.errorBoundary.title')}
          </TextError>
          <button type="button" onClick={() => this.forceReload()}>
            {t('components.errorBoundary.reload')}
          </button>
          {env === 'development' && <TextError>{message}</TextError>}
        </Container>
      );
    }
    return children;
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetStates: actions.resetStates,
    },
    dispatch
  );

ErrorBoundary.defaultProps = {
  resetStates: () => {},
  t: () => {},
};

ErrorBoundary.propTypes = {
  resetStates: lib.PropTypes.func,
  t: lib.PropTypes.func,
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(ErrorBoundary);
